import apiClient from "../config/apiClient";

export const fetchExcuseDuties = async (id, page = 1, limit = 10) => {
  const user = window.localStorage.getItem("token");
  const token = user;
  return await apiClient.get(
    `/public/portal?url=patient/excuse-duties?page=${page}%26limit=${limit}%26patient_id=${id}`,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};
